/**
 * SaleDetailPresenter
 * --
 */
import React from 'react';
import {
  Content,
  Row,
  Col,
  Title,
  InputFormTable,
  Text,
  ModalLayout,
} from 'components';
import { Input, Button, Flex, Select, Table } from 'antd';
import Formatter from 'utils/Formatter';
import { stringToMoneyFormat } from 'utils';
const MENU_TYPES = {
  DESSERT: { label: '디저트', value: 'DESSERT' },
  MD: { label: 'MD', value: 'MD' },
  GENERAL: { label: '일반', value: 'GENERAL' },
  ALC: { label: '주류', value: 'ALC' },
  ETC: { label: '기타', value: 'ETC' },
};
const SaleRegisterPresenter = (props) => {
  const {
    menuList = null,
    userData = null,
    shopList = null,
    categoryList = null,
    //
    onChange = () => {},
    selectedList = [],
    onSelect = () => {},
    modalType = null,
    onModalType = null,
    isOpen = () => {},
    onIsOpen = () => {},
    amountList = [],
    onAmountList = () => {},
    //
    inputValue = null,
    selectedUserPhone = null,
    onSelectedUserPhone = () => {},
  } = props;
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    subTitle: {
      fontSize: 17,
      fontWeight: 500,
      lineHeight: '141%',
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const form = [
    {
      label: '회원 선택',
      form: [
        {
          input: (
            <Flex vertical gap={10}>
              <Flex gap={2} align="center">
                <Input
                  size="large"
                  placeholder="회원 번호 입력"
                  style={{ ...styles.form.input.large, width: 300 }}
                  value={inputValue.user_phone}
                  onChange={(e) =>
                    onChange('user_phone', Formatter.hyphen(e.target.value))
                  }
                  count={{
                    show: true,
                    max: 13,
                  }}
                />
                <Button
                  onClick={() => onSelectedUserPhone(inputValue.user_phone)}
                >
                  조회하기
                </Button>
              </Flex>
              <Flex gap={10}>
                {selectedUserPhone ? (
                  <>
                    <Text>
                      조회된 정보: {'['}회원명:{' '}
                      {userData?.user_name || '비회원'}, 회원 번호:{' '}
                      {userData?.user_phone || selectedUserPhone || '-'}
                      {']'}
                    </Text>
                  </>
                ) : null}
              </Flex>
            </Flex>
          ),
        },
      ],
      required: false,
    },
    {
      label: '매장 선택',
      form: [
        {
          input: (
            <Select
              placeholder="매장 선택"
              size="large"
              style={{ width: 300 }}
              options={shopList?.map((shop) => ({
                label: shop?.shop_information_name,
                value: shop?.shop_information_id,
              }))}
              onChange={(e) => onChange('shop_information_id', e)}
            ></Select>
          ),
        },
      ],
      required: true,
    },
    {
      label: '메뉴 선택',
      form: [
        {
          input: (
            <Button
              onClick={() => {
                console.log('??');
                onModalType('MENU');
                onIsOpen(true);
              }}
            >
              메뉴 선택 하기
            </Button>
          ),
        },
      ],
      required: true,
    },
    ...(inputValue?.product_information?.length
      ? [
          {
            label: '2',
            form: [
              {
                input: <Button>2</Button>,
              },
            ],
            required: true,
          },
        ]
      : []),
  ];
  console.log('menuList', menuList);
  const columns = {
    MENU: [
      {
        title: '메뉴명',
        key: 'menu_name',
        dataIndex: 'menu_name',
        width: 200,
        // ...getColumnSearchProps('promotion_title'),
      },
      {
        title: '카테고리명',
        key: 'product_category_name',
        dataIndex: 'product_category_name',
        width: 200,
        filters: categoryList.map((_item) => ({
          text: _item.product_category_name,
          value: _item.product_category_id,
        })),
        onFilter: (value, record) => record?.includes(value),
        render: (product_category_name) => product_category_name,
        // ...getColumnSearchProps('promotion_title'),
      },
      {
        title: '단가',
        key: 'price',
        dataIndex: 'price',
        width: 200,
        render: (price) => <>{stringToMoneyFormat(price)}원</>,
        sorter: (a, b) => a.price - b.price,
      },
      {
        title: '타입',
        key: 'type',
        dataIndex: 'type',
        width: 50,
        render: (type) => <>{MENU_TYPES[type]?.label}</>,
        filters: Object.entries(MENU_TYPES).map(([key, value]) => ({
          text: value.label,
          value: key,
        })),
        onFilter: (value, record) => record.type === value,
      },
    ],
    AMOUNT: [
      {
        title: '메뉴12323131212',
        key: 'menu_name',
        dataIndex: 'menu_name',
        width: 200,
        // ...getColumnSearchProps('promotion_title'),
      },
      {
        title: '카테고리명',
        key: 'product_category_name',
        dataIndex: 'product_category_name',
        width: 200,
        filters: categoryList.map((_item) => ({
          text: _item.product_category_name,
          value: _item.product_category_id,
        })),
        onFilter: (value, record) => record?.includes(value),
        render: (product_category_name) => product_category_name,
        // ...getColumnSearchProps('promotion_title'),
      },
      {
        title: '단가',
        key: 'price',
        dataIndex: 'price',
        width: 200,
        render: (price) => <>{stringToMoneyFormat(price)}원</>,
        sorter: (a, b) => a.price - b.price,
      },
      {
        title: '타입',
        key: 'type',
        dataIndex: 'type',
        width: 50,
        render: (type) => <>{MENU_TYPES[type]?.label}</>,
        filters: Object.entries(MENU_TYPES).map(([key, value]) => ({
          text: value.label,
          value: key,
        })),
        onFilter: (value, record) => record.type === value,
      },
    ],
  };
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row gutter={[16, 16]}>
        <Col x={24}>
          <Title style={{ ...styles.title }}>주문 생성</Title>
        </Col>
        <Col x={24}>
          <Content maxWidth={'100%'} padding={20}>
            <Title style={{ ...styles.subTitle }}>회원 선택</Title>
            <InputFormTable form={form} />
          </Content>
        </Col>
      </Row>

      <ModalLayout
        type="modal"
        centered
        title={'메뉴 선택'}
        width={'70%'}
        open={isOpen}
        onCancel={() => {
          onIsOpen(false);
          onModalType('MENU');
        }}
        footer={null}
      >
        {modalType === 'MENU' ? (
          <Table
            dataSource={menuList}
            columns={columns[modalType]}
            rowSelection={{
              type: 'checkbox',
              onSelect: (record, selected) =>
                onSelect(selected ? 'checked' : 'unchecked', record),
              onSelectAll: (selected, selectedRows) =>
                onSelect(
                  selected ? 'all-checked' : 'all-unchecked',
                  selectedRows
                ),
              selectedRowKeys: selectedList?.map((area) => area?.menu_id),
            }}
          />
        ) : modalType === 'AMOUNT' ? (
          <Table dataSource={amountList} columns={columns[modalType]} />
        ) : null}
        <Flex justifyContent="flex-end">
          {modalType === 'AMOUNT' && (
            <Button
              type="primary"
              onClick={() => {
                onAmountList([]);
                onModalType('MENU');
              }}
            >
              이전
            </Button>
          )}
          <Button
            type="primary"
            onClick={() => {
              onAmountList(selectedList);
              onModalType('AMOUNT');
            }}
          >
            다음
          </Button>
        </Flex>
      </ModalLayout>
    </Content>
  );
};

export default SaleRegisterPresenter;
